import { render } from "./form.vue?vue&type=template&id=825b37c4"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/polls/form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "825b37c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('825b37c4', __exports__)) {
    console.log('reload')
    api.reload('825b37c4', __exports__)
  }
  
  module.hot.accept("./form.vue?vue&type=template&id=825b37c4", () => {
    console.log('re-render')
    api.rerender('825b37c4', render)
  })

}


export default __exports__